import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PurchasePriceBandReferenceService extends BaseReferenceService {
  constructor() {
    super('PurchasePriceBandReference');
  }
}
